// extracted by mini-css-extract-plugin
export default {"container":"HelpTerminal_container__WuQs0","header":"HelpTerminal_header__fdoAU","description":"HelpTerminal_description__38lOG"};